import { t } from '../../i18n.es.js';
import React from 'react';
import { styled } from '@teko/ui';

const Text = styled.a `
  &,
  &:hover,
  &:focus,
  &:visited {
    color: #047fff;
    text-decoration: none;
  }
`;
const TermAndPolicyText = ({ link = 'https://help.phongvu.vn', text = t('điều kiện sử dụng và chính sách'), className, }) => {
    return (React.createElement(Text, { href: link, target: "_blank", rel: "noopener noferrer", className: className, onClick: (event) => {
            event.stopPropagation();
        } }, text));
};

export { TermAndPolicyText };
